<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Dettaglio abbonamento #' + this.$route.params.id : 'Nuovo abbonamento') + (this.$route.params.id_socio != null ? ' - socio #' + this.$route.params.id_socio : '')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">

                        <b-row class="my-1" v-if="this.$route.params.id_socio == null">
                            <b-col sm="3"><label for="socio">Socio:</label></b-col>
                            <b-col sm="9">

                                <b-input-group>
                                    <b-form-input v-model="socioVis" id="socio" type="text" disabled></b-form-input>
                                    <b-input-group-append>
                                        <!-- <b-btn v-show="socioVis !== ''" variant="secondary" @click="delSocio()">Elimina</b-btn> -->
                                        <b-btn v-show="abbonamento.id == null" variant="primary" @click="selSocio()">Seleziona</b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>

                        <b-row class="my-1">
                            <b-col sm="3"><label for="tipoabbonamento">Tipo abbonamento:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="abbonamento.id_tipoabbonamento" :options="options_tipiabbonamento" id="tipoabbonamento">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>

                        <b-row class="my-1">
                            <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="abbonamento.datainizio" id="datainizio" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="abbonamento.datafine" id="datafine" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row  class="my-1">
                            <b-col sm="3"><label for="importo">Importo:</label></b-col>
                            <b-col sm="9">
                                <b-input-group prepend="€">
                                    <b-form-input v-model="abbonamento.importo" id="importo" type="number"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>

                        <b-row class="my-1">
                            <b-col sm="3"><label for="note">Note:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="note" v-model="abbonamento.note" :rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>

                        <b-row class="my-1">
                            <b-col sm="3"><label for="datafinebloccopreno">Data fine blocco prenotazione:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="abbonamento.datafinebloccopreno" id="datafinebloccopreno" type="date"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="my-1">
                            <b-col sm="3"><label for="flagatt">Attivo:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="abbonamento.flagatt" :options="options_attivo" id="flagatt">

                                </b-form-select>
                            </b-col>
                        </b-row>

                        <b-row class="my-1" v-if="abbonamento.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="abbonamento.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="abbonamento.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="abbonamento.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="abbonamento.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component -->
    <b-modal size="lg" v-model="sociModal.show" title="Seleziona il socio">
        <!-- <p class="my-2">Seleziona il socio</p> -->

        <div class="text-left">
            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="sociModal.filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive small id="main-table" striped hover show-empty :items="sociModal.items" :fields="sociModal.fields" :current-page="sociModal.currentPage" :per-page="sociModal.perPage" :filter="sociModal.filter" :sort-by.sync="sociModal.sortBy" :sort-desc.sync="sociModal.sortDesc"
                @filtered="onFiltered">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="cognome" scope="row">{{row.value}}</template>
                <template slot="nome" scope="row">{{row.value}}</template>
                <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                <template slot="email" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-btn size="sm" variant="danger" @click.stop="seleziona(row.item,row.index,$event.target)">Seleziona</b-btn>
            </template>
            </b-table>


            <div class="row my-1">
                <div class="col-md-7 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="sociModal.perPage" v-model="sociModal.currentPage" />
                </div>
                <div class="col-md-5 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="sociModal.pageOptions" v-model="sociModal.perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>


        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal.show=false" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>
import moment from 'moment'

import {
    ctrlVismenu
} from '../util.js'

import {
    NAMESPACE
} from '../config.js'

import {
    Visibilità,
    Socio
} from '../classes.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {

            namespace: NAMESPACE,
            abbonamento: {
                id: this.$route.params.id || null,
                id_tipoabbonamento: null,
                id_socio: this.$route.params.id_socio || null,
                datainizio: '',
                datafine: '',
                importo: '0',
                flagatt: 'S',
                datains: null,
                uteins: '',
                nomesocio: '',
                cognomesocio: '',
                accountsocio: '',
                flgsocio: '',
                note: '',
                datafinebloccopreno: null,
            },
            error: '',
            options_tipiabbonamentoAux: [],
            options_tipiabbonamento: [],
            options_attivo: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,
            sociModal: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    email: {
                        label: 'Email',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,
                totalRowsFilter: null,
            }
        };
    },
    watch: {
        'abbonamento.id_socio': function(val, oldVal) {

            this.options_tipiabbonamento = this.calcolaTipiAbbonamento();


        },
        'abbonamento.id_tipoabbonamento': function(val, oldVal) {

            var appdettaglio = this;

            var abbonamentosel = this.options_tipiabbonamentoAux.filter(function (element) {
                                                    return element.id == appdettaglio.abbonamento.id_tipoabbonamento;
                                                });

            if(abbonamentosel.length > 0){
                this.abbonamento.importo = abbonamentosel[0].importo;
                if(this.abbonamento.datainizio != null && this.abbonamento.datainizio != ''){
                    var new_date = moment(this.abbonamento.datainizio, "YYYY-MM-DD").add(abbonamentosel[0].ggval - 1, 'days').format("YYYY-MM-DD");
                    this.abbonamento.datafine = new_date;
                }
            }


        },
        'abbonamento.datainizio': function(val, oldVal) {

            var appdettaglio = this;

            var abbonamentosel = this.options_tipiabbonamentoAux.filter(function (element) {
                                                    return element.id == appdettaglio.abbonamento.id_tipoabbonamento;
                                                });

            if(abbonamentosel.length > 0){
                if(this.abbonamento.datainizio != null && this.abbonamento.datainizio != ''){
                    var new_date = moment(this.abbonamento.datainizio, "YYYY-MM-DD").add(abbonamentosel[0].ggval - 1, 'days').format("YYYY-MM-DD");
                    this.abbonamento.datafine = new_date;
                }
            }


        },

    },
    computed:{
        socioVis: {
            // getter
            get: function () {
                if(this.abbonamento.id_socio == null || this.abbonamento.id_socio == 'null' || parseInt(this.abbonamento.id_socio) <= 0){
                    return '';
                }
                else{
                    return this.abbonamento.cognomesocio + " " + this.abbonamento.nomesocio + " - " + this.abbonamento.accountsocio;
                }

            },
            // setter
            set: function (newValue) {

            }
        },
        totalRows: {
            // getter
            get: function () {
                return this.sociModal.totalRowsFilter || this.sociModal.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        seleziona(item, index, button) {

            this.abbonamento.id_socio = item.id;
            this.abbonamento.nomesocio = item.nome;
            this.abbonamento.cognomesocio = item.cognome;
            this.abbonamento.accountsocio = item.email;
            this.abbonamento.flgsocio = item.flgsocio;

            this.sociModal.show = false;

        },
        selSocio() {

            var token = localStorage.getItem('token');
            //this.axios.get(NAMESPACE + 'rest/soci', {
                this.axios.get(NAMESPACE + 'rest/soci/flgatt/S', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            this.sociModal.items = response.data.message;
                            this.sociModal.items.forEach(function(element, index) {
                                delete element.uteins; //per motivi di ricerca
                            });
                            this.sociModal.show = true;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    this.sociModal.showerror = true;
                    this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        insert() {
            var appdettaglio = this;

            if (this.abbonamento.id_socio == "" || this.abbonamento.id_socio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Selezionare il socio!";
            } else if (this.abbonamento.id_tipoabbonamento == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Tipo abbonamento non selezionato!";
            } else if (this.abbonamento.datainizio == "" || this.abbonamento.datainizio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data inizio vuoto!";

            } else if (this.abbonamento.datafine == "" || this.abbonamento.datafine == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data fine vuoto!";

            } else if (this.abbonamento.datafine < this.abbonamento.datainizio) { //sono stringhe yyyy-mm-dd
                appdettaglio.showerror = true;
                appdettaglio.error = "Data inizio maggiore di data fine!";
            } else {

                var json = JSON.stringify(this.abbonamento);

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/abbonamento', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;

                                if (res.length > 0) {
                                    this.abbonamento = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettaglioabbonamento/' + this.abbonamento.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }

                            } else {
                                throw new Error(response.data.message);
                            }

                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

        },
        calcolaTipiAbbonamento(){

            //alert("a");

            var appdettaglio = this;

            return this.options_tipiabbonamentoAux.filter(function (element) {
                                                    //alert("Element: " + JSON.stringify(element));
                                                    var today = moment(String(new Date())).format('YYYY-MM-DD');
                                                    return ((element.flgsocio == appdettaglio.abbonamento.flgsocio || element.flgsocio == 'T') && element.flagatt == 'S' && element.datainizio <= today && today <= element.datafine)
                                                    //ci si para il culo nel caso di abbonamenti passati già selezionati e non più coerenti
                                                    || element.id == appdettaglio.abbonamento.id_tipoabbonamento;
                                                }).map(function(element) {
                                                    return { value: element.id, text: element.descrizione + " - " + element.importo + "€ - " + element.ggval + "gg"};
                                                });

        },
        caricaTipoAbbonamento(){

        var token = localStorage.getItem('token');
        var appdettaglio = this;

        //chiamo il servizio che mi restituisce tutti tipi abbonamento
        this.axios.get(NAMESPACE + 'rest/tipoabbonamento', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        var res = response.data.message;
                        if (res.length > 0) {

                            appdettaglio.options_tipiabbonamentoAux = res;
                            appdettaglio.options_tipiabbonamento = appdettaglio.calcolaTipiAbbonamento();

                            appdettaglio.caricaAbbonamento();

                        } else {
                            throw new Error("Errore categorie non trovate!");
                        }


                    } else {
                        throw new Error(response.data.message);
                    }


                } catch (e) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                appdettaglio.showerror = true;
                appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });


        },
        caricaAbbonamento(){

            var id = this.abbonamento.id; //se è la prima volta si prova a prendere da getid
            var token = localStorage.getItem('token');

            var appdettaglio = this;

            if (id != null) {

                this.axios.get(NAMESPACE + 'rest/abbonamenti/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;

                                if (res.length > 0) {
                                    appdettaglio.abbonamento = res[0];
                                    appdettaglio.showdettaglio = true;


                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

        }
    },
    created: function () {

        if(!ctrlVismenu("A")){
            this.$router.replace('/accessdenied');
            return;
        }

        var token = localStorage.getItem('token');
        var appdettaglio = this;

        if(this.abbonamento.id_socio == null){

            this.caricaTipoAbbonamento();

        }
        else{

            //chiamo il servizio che mi restituisce tutti tipi abbonamento
            this.axios.get(NAMESPACE + 'rest/soci/' + this.abbonamento.id_socio, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                appdettaglio.abbonamento.flgsocio = res[0].flgsocio;

                                //alert("ricevuto: " + appdettaglio.abbonamento.flgsocio);

                                appdettaglio.caricaTipoAbbonamento();

                            } else {
                                throw new Error("Errore categorie non trovate!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }



    },
    mounted: function() {

    }

}
</script>
